<template>
  <div>
    <Header page="attribute"/>
    <div id="content">
      <div style="text-align: left; font-size: 16px;">
        <span style="white-space: pre-wrap;">{{ setting.home_description }}</span>
      </div>
      <Contents target="true" page="attribute"/>
      <div class="mt-4 mx-auto" style="max-width: 900px;">
        <div class="text-left select_attribute">1. 属性選択</div>
        <div style="text-align: left; margin: 24px 0;"><span style="white-space: pre-wrap;">{{ setting.attribute_description }}</span></div>
        <v-radio-group id="attributes" v-model="selectedAttribute"
          style=" border: solid 3px #D9D9D9; margin: 0 auto; padding-top: 24px; max-width: 900px;">
          <template v-for="userAttribute in userAttribute.user_attributes">
            <v-layout row style="margin: 6px 10% 6px 10%;" :key="userAttribute.id">
              <v-radio :value="userAttribute" :label="userAttribute.name"></v-radio>
            </v-layout>
          </template>
        </v-radio-group>
      </div>

      <v-btn id="btn" outlined :disabled="button_disabled"
        v-on:click="doNext"><span style="font-size: 24px;">次へ</span></v-btn>
    </div>
    <Footer style="position: absolute; bottom: 0;"/>
  </div>
</template>
<script>
import Footer from "../components/footer.vue";
import Header from "../components/header.vue";
import Contents from "../components/contents.vue";
export default {
  props: [],
  data() {
    return {
      setting: [],//可変の設定
      userAttribute: [],//userの属性
      selectedAttribute: "",//選択した属性
    }
  },
  created() {
    this.userAttribute = this.$repository.userAttribute;
    this.setting = this.$repository.setting;
  },
  methods: {
    doNext() {
      localStorage.setItem('user_attribute', JSON.stringify(this.selectedAttribute));
      if (!this.selectedAttribute.target_subjects) {
        this.$router.push({ name: 'favorite'});
      }
      else {
        this.$router.push({ name: 'subject'});
      }
    }
  },
  components: {
    Footer,
    Header,
    Contents,
  },
  computed: {
    button_disabled() {
      return !this.selectedAttribute
    }
  }
}
</script>
<style>
/*スマホ画面*/
#content {
  width: auto;
  max-width: 900px;
  margin: 0 5%;
}
#btn {
  background-color: #E76F00;
  color: #FFF;
  width: 100%;
  height: 6em;
  margin-top: 48px;
  margin-bottom: 200px;
}
.select_attribute {
  margin-top: 64px;
  margin-bottom: 12px;
  font-size: 5.33vw;
  border-bottom: solid #00a0e9;
  border-left: 12px solid #faef05;
  max-width: 900px;
  padding-left: 8px;
}
/*タブレット画面*/
@media (min-width: 450px) {
  #btn {
    width: 20em;
  }
  .select_attribute {
    font-size: 24px;
  }
}
/*PC画面*/
@media (min-width: 960px) {
  #content {
    padding-top: 56px;
    margin: 0 auto;
    width: 900px;
  }
}

.theme--light.v-btn.v-btn--disabled{
  color: #FFF !important;
  Opacity: 50%;
}
</style>